import React from 'react';
import { Globe, Smartphone, Database, Shield, Users, BarChart3, Settings, Headphones } from 'lucide-react';

const Services = () => {
    const services = [
        {
            icon: Globe,
            title: 'Web Development',
            description: 'Custom websites and web applications tailored to your finance office needs with responsive design and modern functionality.',
            features: ['Responsive Design', 'SEO Optimized', 'Fast Loading', 'Secure']
        },
        {
            icon: Smartphone,
            title: 'Mobile Apps',
            description: 'Native and cross-platform mobile applications that keep your clients connected and your business accessible anywhere.',
            features: ['iOS & Android', 'Real-time Sync', 'Offline Support', 'Push Notifications']
        },
        {
            icon: Database,
            title: 'Data Management',
            description: 'Comprehensive data solutions including migration, backup, and analytics to help you make informed business decisions.',
            features: ['Data Migration', 'Automated Backups', 'Analytics', 'Reporting']
        },
        {
            icon: Shield,
            title: 'Security Solutions',
            description: 'Enterprise-grade security measures to protect sensitive financial data and ensure compliance with industry standards.',
            features: ['Data Encryption', 'Access Control', 'Compliance', 'Monitoring']
        },
        {
            icon: Users,
            title: 'Client Management',
            description: 'CRM systems designed specifically for finance offices to manage client relationships and streamline communication.',
            features: ['Contact Management', 'Communication Tools', 'Task Tracking', 'Document Storage']
        },
        {
            icon: BarChart3,
            title: 'Analytics & Reporting',
            description: 'Advanced analytics and reporting tools to gain insights into your business performance and client behavior.',
            features: ['Custom Dashboards', 'Real-time Reports', 'Data Visualization', 'Performance Metrics']
        }
    ];

    return (
        <section id="services" className="py-20 bg-white">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-16">
                    <h2 className="text-4xl font-bold text-gray-900 mb-4">Our Services</h2>
                    <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                        We provide comprehensive technology solutions designed specifically for finance offices,
                        from small startups to established mid-size firms.
                    </p>
                </div>

                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {services.map((service, index) => (
                        <div key={index} className="bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 border border-gray-100">
                            <div className="bg-gradient-to-r from-blue-100 to-teal-100 w-16 h-16 rounded-lg flex items-center justify-center mb-6">
                                <service.icon className="w-8 h-8 text-blue-600" />
                            </div>

                            <h3 className="text-xl font-semibold text-gray-900 mb-3">{service.title}</h3>
                            <p className="text-gray-600 mb-6 leading-relaxed">{service.description}</p>

                            <div className="space-y-2">
                                {service.features.map((feature, featureIndex) => (
                                    <div key={featureIndex} className="flex items-center text-sm text-gray-700">
                                        <div className="w-1.5 h-1.5 bg-blue-600 rounded-full mr-3"></div>
                                        {feature}
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>

                <div className="mt-16 text-center">
                    <div className="bg-gradient-to-r from-blue-50 to-teal-50 rounded-2xl p-8">
                        <div className="flex items-center justify-center mb-4">
                            <Headphones className="w-8 h-8 text-blue-600 mr-3" />
                            <h3 className="text-2xl font-semibold text-gray-900">Need Custom Solutions?</h3>
                        </div>
                        <p className="text-gray-600 mb-6 max-w-2xl mx-auto">
                            Every finance office is unique. We offer custom development services to create solutions
                            tailored specifically to your business needs and workflow.
                        </p>
                        <button className="bg-blue-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors">
                            Discuss Your Project
                        </button>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Services;